import { useState, type RefObject } from "react";
import { Input } from "@/components/atoms/input";

export interface DirectiveOptionFieldFreeFormProps {
  /** Associates with a `<Label htmlFor={id}>`. */
  id?: string;
  placeholder?: string;
  initialValue?: string;
  onSubmit: (value: string) => void;
  /** Optional ref for the input (e.g. for focus after auto-open). */
  inputRef?: RefObject<HTMLInputElement | null>;
  /** Default true; set false when the parent schedules focus (e.g. floating builder vs chip). */
  autoFocus?: boolean;
}

/**
 * Free-form text field for one directive option slot. Submit on Enter.
 * Use when the slot has no fixed or suggested options (e.g. singular/plural text).
 */
export const DirectiveOptionFieldFreeForm = ({
  id,
  placeholder,
  initialValue = "",
  onSubmit,
  inputRef,
  autoFocus = true,
}: DirectiveOptionFieldFreeFormProps) => {
  const [value, setValue] = useState(initialValue);
  return (
    <Input
      id={id}
      ref={inputRef}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder={placeholder}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          if (value.trim().length > 0) {
            onSubmit(value);
            setValue("");
          }
        }
      }}
      autoFocus={autoFocus}
    />
  );
};
